import axios from "axios";

const GraphQl = {
    async sendRequest(query, params) { 

        try { 
            let body = typeof (query) === 'string' ? {
                query: query, params: params
            } : query;
            const response = await axios.post(process.env.VUE_APP_GRAPHQL_URL, body)
            return response.data.data;
        } catch (e) {
            console.log(e)
          
        }
    }  
}; 

export default GraphQl;